export const myTimeTranslationsHu = {
  MY_TIME_NO_UNCLOSED_PERIOD: "Nincs lezáratlan időszak!",
  MY_TIME_USER_APPROVAL_ERROR: "A tudomásulvétel sikertelen.",
  MY_TIME_USER_APPROVAL_SUCCESS: "A tudomásulvétel sikeresen megtörtént.",
  MY_TIME_FORCE_APPROVAL_ALL_ERROR: "A csoportos hónapzárás sikertelen.",
  MY_TIME_FORCE_APPROVAL_ALL_SUCCESS: "A csoportos hónapzárás sikeresen megtörtént.",
  MY_TIME_FORCE_APPROVAL_REMOVE_ERROR: "A felhasználó beosztásának feloldása sikertelen.",
  MY_TIME_FORCE_APPROVAL_REMOVE_SUCCESS: "A felhasználó beosztásának feloldása sikeres.",
  MY_TIME_FORCE_APPROVAL_ERROR: "A felhasználó beosztásának elfogadása sikertelen.",
  MY_TIME_FORCE_APPROVAL_SUCCESS: "A felhasználó beosztása sikeresen elfogadva.",
  MY_TIME_APPROVAL_USER_CLOSE_ERROR: "A beosztás elfogadása sikertelen.",
  MY_TIME_UNLOCK_CLOSE_MONTH_INFO: "Valóban feloldja a felhasználó beosztását?",
  MY_TIME_UNLOCK_CLOSE_MONTH_TITLE: "Hónapzárás feloldása",
  MY_TIME_CONFIRM_GROUP_CLOSE_MONTH_TEXT_RESPONSIBILITY: "Munkáltatói felelősségem tudatában kijelentem, hogy a beosztás munkáltatóként történő elfogadását megelőzően a dolgozó tájékoztatására vonatkozó jogszabályi kötelezettségemnek a helyben szokásos és általában ismert módon eleget tettem.",
  MY_TIME_WORKING_SCHEDULE_ACCEPTANCE_ERROR: "Hiba történt a beosztás változás tudomásul vételénél.",
  MY_TIME_WORKING_SCHEDULE_ACCEPT: "Beosztás elfogadása",
  MY_TIME_CONFIRM_GROUP_CLOSE_MONTH_TEXT: "Valóban lezárja a hónapot a kiválasztott dolgozó(k)nak?",
  MY_TIME_FORCE_APPROVAL: "Csoportos hónapzárás",
  MY_TIME_ACKNOWLEDGE: "Tudomásul veszem",
  MY_TIME_10_MINUTES_TIME_PERIOD_INFO:
    "A kérelem kezdő és záró időpontja 10 perces időközönként adható meg. (pl. 08:00, 08.10, stb.)",
  MY_TIME_10_MINUTES_TIME_PERIOD: "10 perc",
  MY_TIME_30_MINUTES_TIME_PERIOD_INFO:
    "A kérelem kezdő és záró időpontja 30 perces időközönként adható meg. (pl. 08:00, 08.30, stb.)",
  MY_TIME_30_MINUTES_TIME_PERIOD: "30 perc",
  MY_TIME_ACCEPTED_OVERTIME: "Elfogadott túlóra",
  MY_TIME_ACTIVE_REQUESTS: "Nyitott kérelmek",
  MY_TIME_ADMIN_GUIDE: "MyTime adminisztrátori kézikönyv",
  MY_TIME_ADMISSION: "Munkaidő jelentés",
  MY_TIME_ALL_APPROVE_SUCEEDED: "A tételek elfogadása sikeresen megtörtént",
  MY_TIME_APPROVE_ALL_REQUESTS_ALLOWED_INFO:
    "Az elbíráló egy dolgozóhoz tartozó összes aktuális kérelmet egyszerre elfogadhatja.",
  MY_TIME_APPROVE_ALL_REQUESTS_ALLOWED: '"Mindet elfogad" gomb',
  MY_TIME_APPROVE_FAILED: "A kérelem elfogadása sikertelen volt",
  MY_TIME_APPROVE_SUCCEEDED: "A kérelem elfogadása sikeresen megtörtént",
  MY_TIME_AVAILABLE_WORKING_BALANCE: "Felhasználható munkaidő egyenleg",
  MY_TIME_BALANCE: "Egyenleg",
  MY_TIME_CATEGORY: "Kategória",
  MY_TIME_CHANGE_ALLOWED_INFO:
    "A dolgozó módosítást adhat be a munkaidő, túlóra, készenlét alatti behívás adataival kapcsolatban.",
  MY_TIME_CHANGE_ALLOWED: "Dolgozói jelentés",
  MY_TIME_CHANGE_WORKING_TIME_ALLOWED: "Beosztás módosítása",
  MY_TIME_CHANGE_WORKING_TIME_ALLOWED_INFO:
    "A dolgozó módosítást adhat be a munkaidejével kapcsolatban.",
  MY_TIME_SHOW_BALANCE_FRAME_ALLOWED: "Egyenleg megjelenítése",
  MY_TIME_SHOW_BALANCE_FRAME_ALLOWED_INFO:
    "Az egyenleg kártya megjelenítése a dolgozói beosztás oldalon.",
  MY_TIME_CLOSE_MONTH: "Hónapzárás",
  MY_TIME_CLOSE_RECORDING_PERIOD_FAILED:
    "A rögzítési időszak lezárása sikertelen volt",
  MY_TIME_CLOSE_RECORDING_PERIOD_SUCCEEDED:
    "A rögzítési időszak lezárása sikeresen megtörtént",
  MY_TIME_CLOSING_BALANCE: "Záró egyenleg",
  MY_TIME_CLOSING_PERIOD: "Hónapzárás",
  MY_TIME_CONFIRM_CLOSE_MONTH_TEXT: "Biztosan lezárja a hónapot?",
  MY_TIME_CONFIRM_CLOSE_MONTH_TITLE: "Hónapzárás megerősítése",
  MY_TIME_CONSCRIPTIONS: "Behívások",
  MY_TIME_CURRENT_BALANCE: "Aktuális egyenleg",
  MY_TIME_DATA_NOT_CHANGED: "Nincs változás az adatokban!",
  MY_TIME_EMPLOYEE_SCHEDULE_PAGE_TITLE: "Beosztás adataim és kérelmeim",
  MY_TIME_EXAMINER_GUIDE: "MyTime elbírálói kézikönyv",
  MY_TIME_EXCEEDS_DAILY_WORKTIME_LIMIT:
    "Meghaladja a napi 12 óra munkaidő értéket",
  MY_TIME_EXCEEDS_STAND_BY_INTERVALL:
    "A behívás rögzítése csak készenlét időtartamában engedélyezett.",
  MY_TIME_EXCEEDS_WEEKLY_VOLUNTARY_OVERTIME_LIMIT:
    "Meghaladja a heti önként vállalt túlmunka értékét",
  MY_TIME_EXCEEDS_WEEKLY_WORKTIME_LIMIT:
    "Meghaladja a lehetséges heti munkaidő értékét",
  MY_TIME_FRAME_PERIOD: "Munkaidőkeret időszak",
  MY_TIME_HOMEOFFICE: "Home Office",
  MY_TIME_LEAVE: "Szabadság",
  MY_TIME_MAX_OVERTIME_IN_HOUR: "Egyéni éves túlórakeret",
  MY_TIME_MY_ADMISSION: "Munkaidő jelentéseim",
  MY_TIME_MY_WORK_TIME_REPORTS: "Beosztás",
  MY_TIME_NO_TIME_PERIOD_INFO:
    "A dolgozó percre pontosan beadhat kérelmet. (pl. 08:00, 08:05, stb.)",
  MY_TIME_NO_TIME_PERIOD: "Nincs",
  MY_TIME_ON_CALL: "Ügyelet",
  MY_TIME_ONE_OVERTIME_ALLOWED_TEXT: "Erre a napra már van rögzítve túlóra!",
  MY_TIME_OPENING_BALANCE: "Nyitó egyenleg",
  MY_TIME_OTHER: "Egyéb",
  MY_TIME_OVERTIME_NOT_ALLOWED_TEXT:
    "Erre a napra nem lehet kérelmet rögzíteni!",
  MY_TIME_OVERTIME: "Túlóra",
  MY_TIME_OVERTIMES: "Túlórák",
  MY_TIME_PERSONAL_LEAVE: "Magáncélú távollét",
  MY_TIME_PERSONAL_LEAVE_REQUIRES_WORKING_TIME: "A magáncélú távollét csak munkaidőn belül rögzíthető!",
  MY_TIME_PAID_HOLLIDAY: "Fizetett ünnep",
  MY_TIME_PERIOD_NOT_APPROPRIATE:
    "A bevitt időpont nem felel meg a beállításoknak.",
  MY_TIME_PERIOD_TEXT: "Jelenlét időszak",
  MY_TIME_RECORDING_PERIOD: "Rögzítési időszak",
  MY_TIME_REJECT_FAILED: "A kérelem visszautasítása sikertelen volt",
  MY_TIME_REJECT_SUCCEEDED: "A kérelem visszautasítása sikeresen megtörtént",
  MY_TIME_REPORTS_CHANGES: "Beosztásváltozások",
  MY_TIME_REQUEST_CREATE_FAILED: "A kérelem létrehozása sikertelen volt",
  MY_TIME_REQUEST_CREATE_SUCCEEDED:
    "A kérelem létrehozása sikeresen megtörtént",
  MY_TIME_REQUEST_DELETE_FAILED: "A kérelem visszavonása sikertelen volt",
  MY_TIME_REQUEST_DELETE_SUCCEEDED:
    "A kérelem visszavonása sikeresen megtörtént",
  MY_TIME_REQUEST_NOT_FOUND: "Nincs nyitott kérelem!",
  MY_TIME_REQUESTS: "MyTime kérelmek",
  MY_TIME_REST_DAY: "Pihenőnap",
  MY_TIME_STAND_BY_CALL: "Behívás",
  MY_TIME_STAND_BY: "Készenlét",
  MY_TIME_TIME_PERIOD_SETTINGS: "Igényelhető időtartam",
  MY_TIME_TYPE: "Jelenlét típusa",
  MY_TIME_UNEXAMINED_REQUESTS: "Nyitott, elbíráló nélküli kérelmek",
  MY_TIME_USER_GUIDE: "MyTime felhasználói kézikönyv",
  MY_TIME_VOLUNTARY_OVERTIME: "Önként vállalt túlóra",
  MY_TIME_WORK_ORDER: "Munkarend",
  MY_TIME_WORK_TIME_FRAME: "Ledolgozandó",
  MY_TIME_WORKDAY: "Munkanap",
  MY_TIME_WORKED_TIME_FRAME: "Ledolgozott",
  MY_TIME_WORKING_SCHEDULE: "Beosztás",
  MY_TIME_WORKING_TIME_ITEM: "Altétel",
  MY_TIME_WORKING_TIME: "Munkaidő",
  MY_TIME_ZERO_DURATION_NOT_ALLOWED: "A kezdő és záró időpont nem lehet azonos!",
  MY_TIME_NEGATIVE_DURATION_NOT_ALLOWED: "A záró időpont nem lehet korábbi a kezdőnél!",
  MY_TIME_APPROVAL_ALLOWED_INFO:
    "A dolgozó igazolhatja a beosztása tudomásulvételét és az időszak végén elfogadhatja a munkaidő kimutatását.",
  MY_TIME_APPROVAL_ALLOWED: "Dolgozói beosztás elfogadása",
  MY_TIME_NOT_APPROVED_TIMESHEETS_WO_EXAMINER:
    "Le nem zárt hónapok elbíráló nélkül",
  MY_TIME_NOT_APPROVED_TIMESHEETS: "Le nem zárt hónapok",
  MY_TIME_NOT_AUTHORIZED_TIMESHEETS: "Nem jóváhagyott munkaidő beosztások",
  MY_TIME_NOT_AUTHORIZED_TIMESHEETS_WO_EXAMINER:
    "Nem jóváhagyott munkaidő beosztások elbíráló nélkül",
  MY_TIME_DASHBOARD: "Beosztások áttekintése",
  MY_TIME_CLOSED_MONTH: "Lezárt hónap",
  MY_TIME_APPROVED: "Elfogadta",
  MY_TIME_ACKNOWLEDGED: "Tudomásul vette",
  MY_TIME_MY_EXAMINED_USERS: "Elbíráltjaim",
  MY_TIME_APPROVAL_USER_CLOSE_SUCCESS: "A hónapzárás sikeresen megtörtént.",
  MY_WORK_TIME_REPORTS: "Beosztás",
  MY_TIME_ABSENCE: "Hiányzás",
  MY_TIME_APPROVAL_ALLOWED_BY_THE_EXAMINER: "Dolgozói beosztás jóváhagyása",
  MY_TIME_APPROVAL_ALLOWED_BY_THE_EXAMINER_INFO: "Az elbíráló jóváhagyhatja a dolgozó beosztását.",
  MY_TIME_FORCE_AUTHORIZATION: "Csoportos jóváhagyás",
  MY_TIME_AUTHORIZATION: "Jóváhagyom",
  MY_TIME_AUTHORIZED: "Jóváhagyva",
  MY_TIME_AUTHORIZATION_CONFIRMATION: "Jóváhagyás megerősítése",
  MY_TIME_AUTHORIZATION_CONFIRMATION_INFO: "Valóban jóváhagyja a beosztását a kiválasztott dolgozó(k)nak?",
};
